/**
 * The translation catalogue. Importing this module parses the full en.json
 * (660+ KB) at module scope — import it eagerly only where the app genuinely
 * boots with translations (LanguageProvider). Lazy consumers (e.g. the
 * Storybook preview) should load it with a dynamic `import()` instead.
 */
import { DEFAULT_LOCALE } from './constants'
import enTranslationMessages from './translations/en.json'

const formatTranslationMessages = (
  locale: string,
  messages: { [key: string]: string }
) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {}

  const flattenFormattedMessages = (
    formattedMessages: { [key: string]: string },
    key: string
  ) => {
    const formattedMessage: string =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key]
    return Object.assign(formattedMessages, { [key]: formattedMessage })
  }

  return Object.keys(messages).reduce(flattenFormattedMessages, {})
}

export const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
}
